import(/* webpackMode: "eager" */ "/codebuild/output/src1342722274/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
